import { FC, useMemo } from 'react';
import { SvgIcon } from '@edikk-edikk/svg-icon';
import TwitchSvg from '#srcIcons/socials/twitch.svg';
import OnlyfansSvg from '#srcIcons/socials/onlyfans.svg';
import FanslySvg from '#srcIcons/socials/fansly.svg';
import TelegramSvg from '#srcIcons/socials/telegram.svg';
import WhatsappSvg from '#srcIcons/socials/whatsapp.svg';
import InstagramSvg from '#srcIcons/socials/instagram.svg';
import XTwitterSvg from '#srcIcons/socials/x-twitter.svg';
import SignalSvg from '#srcIcons/socials/signal.svg';
import { SocialLinkAlias } from '#components/social-link';
import socialLinkCss from '../../assets/social-link/social-link.module.scss';

type PropsType = {
  alias: string;
};

const SocialLinkIcon: FC<PropsType> = ({
  alias,
}) => {
  const Icon = useMemo(() => {
    switch (alias) {
      case SocialLinkAlias.whatsApp:
        return WhatsappSvg;
      case SocialLinkAlias.instagram:
        return InstagramSvg;
      case SocialLinkAlias.telegram:
        return TelegramSvg;
      case SocialLinkAlias.twitch:
        return TwitchSvg;
      case SocialLinkAlias.fansly:
        return FanslySvg;
      case SocialLinkAlias.onlyFans:
        return OnlyfansSvg;
      case SocialLinkAlias.xTwitter:
        return XTwitterSvg;
      case SocialLinkAlias.signal:
        return SignalSvg;
      default:
        return null;
    }
  }, [alias]);

  if (!Icon) {
    return null;
  }

  return (
    <SvgIcon
      Component={Icon}
      width={null}
      height={null}
      additionalClassName={socialLinkCss.socialLink__icon}
      colored
      isNeedWrap={false}
    />
  );
};

export { SocialLinkIcon };
